import i18n from 'i18next';

const getTagNameByLanguage = (tagName: string): string => {
  const translations: { [key: string]: string } = {
    'Contract Document': i18n.t('tagContractDocument'),
    'Template or Form': i18n.t('tagTemplateOrForm'),
    'Product Information': i18n.t('tagProductInformation'),
    'My Document': i18n.t('tagMyDocument'),
  };

  return translations[tagName] || tagName;
};

export default getTagNameByLanguage;